import { z } from "zod";

export const listQuery = z.object({
  q: z.string().trim().max(100).optional(),
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export type ApiError = { error: { code: string; message: string; fields?: Record<string, string> } };
/**
 * `summary.count` é o total de registros do filtro (não o tamanho da página). Em `/deletions` (Task 7) vem igual em
 * todas as páginas; em `/contacts` (Task 9) vem só na primeira, e as páginas com `cursor` trazem -1.
 */
export type ListResult<T> = { data: T[]; nextCursor: string | null; summary: { count: number } };
